<template>
  <div class="box4">
    <pageTitle
      title="想要职业发展更广阔 硬核技能需掌握"
      text="掌握更多数据分析硬核技能，做中/高级数据分析师，<br/>薪资才能水涨船高！"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div
      class="content"
      v-for="(item, index) in list"
      :key="index"
      :class="{ item: index == 0, item1: index == 1, item2: index == 2 }"
    >
      <div class="title">{{ item.title }}</div>
      <div class="salary">{{ item.salary }}</div>
      <div class="require">
        <div class="icon"></div>
        基本技能要求
      </div>
      <div class="p1">{{ item.p1 }}</div>
      <div class="skill">
        <div class="icon"></div>
        技术点
      </div>
      <div class="p1">{{ item.exp }}</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          salary: "薪资：8-12K",
          title: "初级数据分析师",
          require: "基本技能要求",
          p1: "熟悉数据分析思维与流程,能够掌握Excel/SQL/可视化（Tableau/PowerBI）等常用工具的使用",

          point: "技术点",
          exp: "数据分析思维、数据分析方法论SQL、Excel、Tableau ",
        },
        {
          salary: "薪资：15-25K",
          title: "中级数据分析师",
          require: "基本技能要求",
          p1: "能够精通常用的数据分析方法和业务模型精通传统数据分析工具与数据科学应用工具能够理解常见数据挖掘与机器学习原理",

          point: "技术点",
          exp: "常见业务分析案例、Python、爬虫、数据库、数据可视化、Numpy、Pandas、统计学相关",
        },
        {
          salary: "薪资：25-50K",
          title: "高级数据分析师",
          require: "基本技能要求",
          p1: "精通大规模数据集分析与应用的核心技能能够处理复杂业务的数据挖掘与优化熟悉数据驱动以及决策的推进与应用",

          point: "技术点",
          exp: "机器学习、数据挖掘、综合项目、数据决策与应用",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0 58px;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box4/bgc.png")
    no-repeat;
  background-size: cover;

  .content {
    padding: 40px;
    box-sizing: border-box;
    position: relative;
    width: 694px;
    margin: 0 auto 30px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .salary {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 34px;
      top: 16px;
      right: 28px;
      position: absolute;
    }
    .require,
    .skill {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #2f8fd6;
      line-height: 34px;
      display: flex;
      align-items: center;
      margin: 28px 0 16px;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 12px;
      }
    }
    .skill {
      margin-top: 20px;
    }
    .p1 {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .item {
    background: url("../../../assets/coursePage/dataAnalysis/box4/item1.png")
      no-repeat;
    background-size: cover;
    margin-top: 48px;
    height: 396px;
    .icon {
      background: url("../../../assets/coursePage/dataAnalysis/box4/icon1.png")
        no-repeat;
      background-size: cover;
    }
  }
  .item1 {
    background: url("../../../assets/coursePage/dataAnalysis/box4/item2.png")
      no-repeat;
    background-size: cover;
    height: 476px;
    .require,
    .skill {
      color: #ff9500;
    }
    .icon {
      background: url("../../../assets/coursePage/dataAnalysis/box4/icon2.png")
        no-repeat;
      background-size: cover;
    }
  }
  .item2 {
    background: url("../../../assets/coursePage/dataAnalysis/box4/item3.png")
      no-repeat;
    background-size: cover;
    height: 396px;

    .salary {
      right: 24px;
    }
    .require,
    .skill {
      color: #00ca7c;
    }
    .icon {
      background: url("../../../assets/coursePage/dataAnalysis/box4/icon3.png")
        no-repeat;
      background-size: cover;
    }
  }
}
</style>
